import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Users, BookOpen, Search, ChevronDown, ChevronUp, Sparkles } from 'lucide-react';
import { Input } from '../../components/ui/input';

// Mool Shakha (Main Branch) and Nukh data
// 12 Mool Shakhas with their associated Nukhs
const moolNukhData = [
  {
    id: 'mehra',
    name: 'मेहरा',
    nameEn: 'Mehra',
    subdivisions: ['मेहर (Mehar)', 'कीरी (Kiri)', 'ठाठागड़ (Thathagadh)', 'डमरावाढा (Damrawadha)', 'छाटबार (Chhatbar)', 'मामतोरा (Mamtora)', 'मणियार (Maniyar)', 'वाढेर (Vadher)']
  },
  {
    id: 'tandan',
    name: 'टण्डन',
    nameEn: 'Tandan',
    subdivisions: ['जोगी (Jogi)', 'टोकला (Tokla)', 'टाटारिया (Tatariya)', 'जाड़ा (Jada)', 'रसभूदड़ा (Rasbhudra)', 'कहिरच (Kahirch)', 'लीया (Liya)', 'जगहूत (Jaghut)']
  },
  {
    id: 'kapur',
    name: 'कपूर',
    nameEn: 'Kapur',
    subdivisions: ['खसिया (Khasiya)', 'रबारा (Rabara)', 'बरवा (Barwa)', 'गोरातेला (Goratela)', 'शनिश्चरा (Shanichara)', 'गेला (Gela)', 'काटबामणा (Katbamana)', 'हरगण (Hargan)']
  },
  {
    id: 'soning',
    name: 'सोनींग',
    nameEn: 'Soning',
    subdivisions: ['खख्खड़ (Khakhad)', 'जारेचा (Jarecha)', 'खाखूपोतरा (Khakhupotra)', 'बगरीया (Bagariya)', 'दुबल (Dubal)', 'डेआणी (Deani)', 'सधिया (Sadhiya)', 'दगिया (Dagiya)']
  },
  {
    id: 'talval',
    name: 'ताल वाल',
    nameEn: 'Tal Val',
    subdivisions: ['तानीओडा (Tanioda)', 'गजकंद (Gajkand)', 'दादडा (Dadra)', 'पातार (Patar)', 'तुतिया (Tutiya)', 'धांधा (Dhandha)', 'डोर (Dor)', 'करसेल (Karsel)']
  },
  {
    id: 'chopda',
    name: 'चौपड़ा',
    nameEn: 'Chopda',
    subdivisions: ['चच्चा (Chachcha)', 'वलेरा (Valera)', 'धनदे (Dhande)', 'खोहा (Khoha)', 'चमरिया (Chamariya)', 'सिंधवड़ (Singhwad)', 'रायत (Rayat)', 'केड़िया (Kediya)']
  },
  {
    id: 'bohra',
    name: 'बोहरा',
    nameEn: 'Bohra',
    subdivisions: ['धड़ा (Dhada)', 'भेड़ा (Bheda)', 'खथुरिया (Khathuriya)', 'घूमरा (Ghumra)', 'डडिया (Dadiya)', 'कालातेला (Kalatela)', 'टंगर (Tangar)', 'दतडा (Datda)']
  },
  {
    id: 'kakkad',
    name: 'कक्कड़',
    nameEn: 'Kakkad',
    subdivisions: ['मच्छर (Machhar)', 'भगाड़ (Bhagad)', 'डलोरा (Dalora)', 'बिछड़ा (Bichhda)', 'ककैया (Kakaiya)', 'ढंकण (Dhankan)', 'विंछी (Vichhi)', 'काटकिया (Katkiya)']
  },
  {
    id: 'setia',
    name: 'सेठिया',
    nameEn: 'Setia',
    subdivisions: ['मकड़िया (Makadiya)', 'बोसमीया (Bosmiya)', 'नानसी (Nanasi)', 'सोमेश्वर (Someshwar)', 'सेता (Seta)', 'सूंठिया (Sundhiya)', 'वारडे (Varde)', 'सोनेजा (Soneja)']
  },
  {
    id: 'upal',
    name: 'उपल',
    nameEn: 'Upal',
    subdivisions: ['आशरा (Ashara)', 'जाजल (Jajal)', 'बिजलीवाडा (Bijliwada)', 'वामावाढा (Vamawada)', 'मोहनवाढा (Mohanwadha)', 'पडिया (Padia)', 'नाहेसरवाढा (Nahesarvadha)', 'जलभूवाढा (Jalbhuwadha)']
  },
  {
    id: 'gangval',
    name: 'गंगवाल',
    nameEn: 'Gangval',
    subdivisions: ['छूंछा (Chhunchha)', 'भूत (Bhoot)', 'निर्मल (Nirmal)', 'जगड (Jagad)', 'खुड़खुड़िया (Khudkhudiya)', 'गिराछ (Girach)', 'गोदड़ा (Godra)', 'टंडण (Tandan)']
  },
  {
    id: 'mehadru',
    name: 'मेंहदरू',
    nameEn: 'Mehadru',
    subdivisions: ['मांधू (Mandhu)', 'कूंकणा (Kunkna)', 'डाक (Dak)', 'हंजा (Hanja)', 'हरचरपाढा (Harcharpadha)', 'धुन (Dhun)', 'धीणीया (Dhiniya)', 'डेडाणी (Dedani)']
  }
];

// Gotra to Nukh mapping data (Source: Shri Bhanwar Lalji Jarecha's book)
const gotraData = [
  { id: 1, name: 'कश्यप', nameEn: 'Kashyap', nukhs: 'कालातेला, मणियार, हरगण, करसेल', nukhsEn: 'Kalatela, Maniyar, Hargan, Karsel' },
  { id: 2, name: 'शाण्डील्य', nameEn: 'Shandilya', nukhs: 'कहिरच, रसभूदड़ा, हरचरपाढा, दादडा, खोहा, पडिया, डाक, गजकंद, धुन, धांधा', nukhsEn: 'Kahirch, Rasbhudra, Harcharpadha, Dadra, Khoha, Padia, Dak, Gajkand, Dhun, Dhandha' },
  { id: 3, name: 'नैध्रुव', nameEn: 'Naidhruv', nukhs: 'वारडे, मांधू, सेता, नाहेसरवाढा', nukhsEn: 'Varde, Mandhu, Seta, Nahesarvadha' },
  { id: 4, name: 'वशिष्ठ', nameEn: 'Vashisth', nukhs: 'दगिया, जारेचा, बगरीया, भगाड़, ककैया, बोसमीया, गेला', nukhsEn: 'Dagiya, Jarecha, Bagariya, Bhagad, Kakaiya, Bosmiya, Gela' },
  { id: 5, name: 'कौडिन्य', nameEn: 'Kaundinya', nukhs: 'कीरी, मेहर, धड़ा, भेड़ा, जाड़ा, डोर, ढंकण, सोनेजा, आशरा', nukhsEn: 'Kiri, Mehar, Dhada, Bheda, Jada, Dor, Dhankan, Soneja, Ashara' },
  { id: 6, name: 'पाराशर', nameEn: 'Parashar', nukhs: 'खथुरिया, काटकिया, गिराछ, जगड', nukhsEn: 'Khathuriya, Katkiya, Girach, Jagad' },
  { id: 7, name: 'लोवाक्ष', nameEn: 'Laukash', nukhs: 'केड़िया', nukhsEn: 'Kediya' },
  { id: 8, name: 'गौतम', nameEn: 'Gautam', nukhs: 'पातार, हंजा', nukhsEn: 'Patar, Hanja' },
  { id: 9, name: 'वामदेव', nameEn: 'Vamdev', nukhs: 'दतडा, डडिया, टंगर', nukhsEn: 'Datda, Dadiya, Tangar' },
  { id: 10, name: 'भारद्वाज', nameEn: 'Bhardwaj', nukhs: 'ठाठागड़, टाटारिया, बिछड़ा, सिंधवड़, खसिया, जाजल, काटबामणा, खाखूपोतरा', nukhsEn: 'Thathagadh, Tatariya, Bichhda, Singhwad, Khasiya, Jajal, Katbamana, Khakhupotra' },
  { id: 11, name: 'गर्ग', nameEn: 'Garg', nukhs: 'घूमरा, बिजलीवाडा, वामावाढा, टंडण', nukhsEn: 'Ghumra, Bijliwada, Vamawada, Tandan' },
  { id: 12, name: 'कपिल', nameEn: 'Kapil', nukhs: 'छाटबार, चमरिया, रायत', nukhsEn: 'Chhatbar, Chamariya, Rayat' },
  { id: 13, name: 'हरितस', nameEn: 'Haritasa', nukhs: 'तुतिया, वलेरा, डलोरा', nukhsEn: 'Tutiya, Valera, Dalora' },
  { id: 14, name: 'कण्व', nameEn: 'Kanva', nukhs: 'खख्खड़, विंछी, जोगी, मकड़िया', nukhsEn: 'Khakhad, Vichhi, Jogi, Makadiya' },
  { id: 15, name: 'विष्णुवर्धन', nameEn: 'Vishnuvardhan', nukhs: 'चच्चा, गोरातेला, लीया', nukhsEn: 'Chachcha, Goratela, Liya' },
  { id: 16, name: 'मुद्गल', nameEn: 'Mudgal', nukhs: 'मच्छर, खुड़खुड़िया, डेडाणी, डेआणी', nukhsEn: 'Machhar, Khudkhudiya, Dedani, Deani' },
  { id: 17, name: 'निव्युंदन', nameEn: 'Nivyundan', nukhs: 'टोकला, नानसी, सूंठिया, दुबल', nukhsEn: 'Tokla, Nanasi, Sundhiya, Dubal' },
  { id: 18, name: 'जमदग्नी', nameEn: 'Jamadagni', nukhs: 'गोदड़ा, बरवा', nukhsEn: 'Godra, Barwa' },
  { id: 19, name: 'वत्स', nameEn: 'Vatsa', nukhs: 'डमरावाढा, छूंछा, निर्मल', nukhsEn: 'Damrawadha, Chhunchha, Nirmal' },
  { id: 20, name: 'कौशिक', nameEn: 'Kaushik', nukhs: 'मामतोरा, वाढेर', nukhsEn: 'Mamtora, Vadher' },
  { id: 21, name: 'धनन्जय', nameEn: 'Dhananjay', nukhs: 'धनदे, धीणीया, सधिया', nukhsEn: 'Dhande, Dhiniya, Sadhiya' },
  { id: 22, name: 'बाभ्रव्य', nameEn: 'Babhravya', nukhs: 'तानीओडा, सोमेश्वर, कूंकणा', nukhsEn: 'Tanioda, Someshwar, Kunkna' },
  { id: 23, name: 'अत्रि', nameEn: 'Atri', nukhs: 'भूत, मोहनवाढा, जलभूवाढा', nukhsEn: 'Bhoot, Mohanwadha, Jalbhuwadha' },
  { id: 24, name: 'अगस्त्य', nameEn: 'Agastya', nukhs: 'शनिश्चरा, रबारा, जगहूत', nukhsEn: 'Shanichara, Rabara, Jaghut' }
];

const BranchesAndNukhsPage = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [expandedNukh, setExpandedNukh] = useState(null);
  const [activeTab, setActiveTab] = useState('nukh');

  // Search functionality
  const filteredNukhs = moolNukhData.filter(nukh => {
    const searchLower = searchTerm.toLowerCase();
    return nukh.name.includes(searchTerm) ||
           nukh.nameEn.toLowerCase().includes(searchLower) ||
           nukh.subdivisions.some(sub => sub.toLowerCase().includes(searchLower));
  });

  const filteredGotras = gotraData.filter(gotra => {
    const searchLower = searchTerm.toLowerCase();
    return gotra.name.includes(searchTerm) ||
           gotra.nameEn.toLowerCase().includes(searchLower) ||
           gotra.nukhs.includes(searchTerm) ||
           gotra.nukhsEn.toLowerCase().includes(searchLower);
  });

  const toggleNukh = (nukhId) => {
    setExpandedNukh(expandedNukh === nukhId ? null : nukhId);
  };

  // Highlight search term in text
  const highlightText = (text, search) => {
    if (!search) return text;
    const parts = text.split(new RegExp(`(${search})`, 'gi'));
    return parts.map((part, i) =>
      part.toLowerCase() === search.toLowerCase() 
        ? <mark key={i} className="bg-yellow-200 px-0.5 rounded">{part}</mark>
        : part
    );
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-orange-50 to-white">
      {/* Hero Section */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="bg-gradient-to-r from-primary to-orange-600 text-white py-16"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2 }}
            className="text-center"
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-4">गोत्र, शाखाएं व नुख</h1>
            <p className="text-xl text-orange-100">Gotras, Branches and Nukhs of Brahmkshatriya Samaj</p>
          </motion.div>
        </div>
      </motion.div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Stats Bar */}
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.3 }}
          className="grid grid-cols-3 gap-4 mb-8"
        >
          <div className="bg-white rounded-xl shadow-sm p-4 text-center border border-orange-100">
            <div className="text-3xl font-bold text-primary">12</div>
            <div className="text-sm text-gray-600">मूल शाखाएं</div>
            <div className="text-xs text-gray-400">Mool Branches</div>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-4 text-center border border-orange-100">
            <div className="text-3xl font-bold text-primary">96</div>
            <div className="text-sm text-gray-600">नुख</div>
            <div className="text-xs text-gray-400">Nukhs</div>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-4 text-center border border-orange-100">
            <div className="text-3xl font-bold text-primary">29</div>
            <div className="text-sm text-gray-600">गोत्र</div>
            <div className="text-xs text-gray-400">Gotras</div>
          </div>
        </motion.div>

        {/* Search Bar */}
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.4 }}
          className="mb-8"
        >
          <div className="relative max-w-md mx-auto">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={20} />
            <Input
              type="text"
              placeholder="खोजें... (Search Gotra, Nukh)"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-10 py-6 text-lg rounded-xl border-orange-200 focus:border-primary"
            />
          </div>
        </motion.div>

        {/* Tab Navigation */}
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="flex justify-center gap-4 mb-8"
        >
          <button
            onClick={() => setActiveTab('nukh')}
            className={`px-6 py-3 rounded-xl font-semibold transition-all ${
              activeTab === 'nukh'
                ? 'bg-primary text-white shadow-lg'
                : 'bg-white text-gray-700 hover:bg-orange-50 border border-orange-200'
            }`}
          >
            <Users className="inline-block mr-2" size={18} />
            मूलशाखा व नुख
          </button>
          <button
            onClick={() => setActiveTab('gotra')}
            className={`px-6 py-3 rounded-xl font-semibold transition-all ${
              activeTab === 'gotra'
                ? 'bg-primary text-white shadow-lg'
                : 'bg-white text-gray-700 hover:bg-orange-50 border border-orange-200'
            }`}
          >
            <BookOpen className="inline-block mr-2" size={18} />
            गोत्र
          </button>
        </motion.div>

        {/* Nukh Section */}
        {activeTab === 'nukh' && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            {/* Nukh Introduction */}
            <div className="bg-gradient-to-r from-orange-50 to-amber-50 rounded-2xl p-6 mb-8 border border-orange-100">
              <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2">
                <Sparkles className="text-primary" size={24} />
                मूलशाखा व नुख
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  नुख का संबंध हमारे वंश या कुल से है। यह गोत्र नहीं है। गोत्र का संबंध ऋषि से है। नुख का संबंध हमारे भौतिक कुल से है। अतः गोत्र व नुख का अंतर समझना आवश्यक है।
                </p>
                <p>
                  ब्रह्मक्षत्रियों की 12 मूल शाखाएं व 96 नुख हैं, ऐसा बताया गया है। लेकिन समग्र तोर पर इससे ज्यादा नुखों का वर्णन भी आया है।
                </p>
                <p>
                  सभी नुखों के परिवार सभी स्थानों पर नहीं पाये जाते हैं। कुछ नुखों के परिवार मारवाड़ क्षेत्र में तो कुछ गुजरात क्षेत्र में पाये जाते हैं। कुछ नुखें सिंधी ब्रह्मक्षत्रियों में पाई जाती हैं। बहुत कम नुखें सभी स्थानों व सभी वर्गों में पायी जाती हैं।
                </p>
                <p className="font-medium text-primary">
                  एक ही नुख के युवक युवती का विवाह हमारे यहां वर्जित है, क्योंकि एक ही नुख के सभी परिवारों में भाइपा माना जाता है।
                </p>
                <p className="text-sm text-gray-600 italic">
                  मूल शाखाओं व नुखों का विवरण यहाँ दिया जा रहा है।
                </p>
              </div>
            </div>

            {/* Nukh Cards */}
            <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
              {filteredNukhs.map((nukh, index) => (
                <motion.div
                  key={nukh.id}
                  initial={{ y: 20, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: index * 0.05 }}
                  className="bg-white rounded-xl shadow-sm border border-orange-100 overflow-hidden hover:shadow-md transition-shadow"
                >
                  <button
                    onClick={() => toggleNukh(nukh.id)}
                    className="w-full p-4 flex items-center justify-between text-left hover:bg-orange-50 transition-colors"
                  >
                    <div>
                      <div className="flex items-center gap-2">
                        <span className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center text-primary font-bold text-sm">
                          {index + 1}
                        </span>
                        <div>
                          <h3 className="font-bold text-gray-800">
                            {highlightText(nukh.name, searchTerm)}
                          </h3>
                          <p className="text-sm text-gray-500">
                            {highlightText(nukh.nameEn, searchTerm)}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center gap-2">
                      <span className="text-xs bg-orange-100 text-primary px-2 py-1 rounded-full">
                        {nukh.subdivisions.length} नुख
                      </span>
                      {expandedNukh === nukh.id ? (
                        <ChevronUp className="text-gray-400" size={20} />
                      ) : (
                        <ChevronDown className="text-gray-400" size={20} />
                      )}
                    </div>
                  </button>

                  {expandedNukh === nukh.id && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      className="border-t border-orange-100 bg-orange-50/50 p-4"
                    >
                      <div className="grid grid-cols-2 gap-2">
                        {nukh.subdivisions.map((sub, idx) => (
                          <div
                            key={idx}
                            className="bg-white px-3 py-2 rounded-lg text-sm border border-orange-100"
                          >
                            {highlightText(sub, searchTerm)}
                          </div>
                        ))}
                      </div>
                    </motion.div>
                  )}
                </motion.div>
              ))}
            </div>

            {filteredNukhs.length === 0 && (
              <div className="text-center py-12 text-gray-500">
                <Users size={48} className="mx-auto mb-4 opacity-50" />
                <p>कोई मिलान नहीं मिला / No matching nukh found</p>
              </div>
            )}

            {/* Quick Reference Table */}
            <motion.div
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.6 }}
              className="mt-12"
            >
              <h3 className="text-xl font-bold text-gray-800 mb-4">
                त्वरित संदर्भ / Quick Reference
              </h3>
              <div className="bg-white rounded-xl shadow-sm border border-orange-100 overflow-hidden">
                <div className="overflow-x-auto">
                  <table className="w-full">
                    <thead className="bg-gradient-to-r from-primary to-orange-500 text-white">
                      <tr>
                        <th className="px-4 py-3 text-left text-sm font-semibold">क्र.</th>
                        <th className="px-4 py-3 text-left text-sm font-semibold">मूल शाखा</th>
                        <th className="px-4 py-3 text-left text-sm font-semibold">Branch Name</th>
                        <th className="px-4 py-3 text-center text-sm font-semibold">नुख संख्या</th>
                      </tr>
                    </thead>
                    <tbody>
                      {moolNukhData.map((nukh, idx) => (
                        <tr
                          key={nukh.id}
                          className={`border-b border-orange-50 ${idx % 2 === 0 ? 'bg-white' : 'bg-orange-50/30'}`}
                        >
                          <td className="px-4 py-3 text-gray-600">{idx + 1}</td>
                          <td className="px-4 py-3 font-medium text-gray-800">{nukh.name}</td>
                          <td className="px-4 py-3 text-gray-600">{nukh.nameEn}</td>
                          <td className="px-4 py-3 text-center">
                            <span className="bg-primary/10 text-primary px-2 py-1 rounded-full text-sm">
                              {nukh.subdivisions.length}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}

        {/* Gotra Section */}
        {activeTab === 'gotra' && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            {/* Gotra Introduction */}
            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-6 mb-8 border border-blue-100">
              <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2">
                <BookOpen className="text-blue-600" size={24} />
                गोत्र
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  गोत्र हिंदु धर्म में एक प्राचीन सामाजिक व धार्मिक व्यवस्था है, जो व्यक्ति के वंश या कुल को एक ऋषि पूर्वज से जोड़ती है। गोत्र उन लोगों के समूह को दर्शाता है, जिनका वंश एक ही ऋषि से अटूट रुप से जुड़ा हुआ है। यह वैदिक काल से चली आ रही परंपरा है, सप्तऋषियों पर आधारित है। समय के साथ अन्य गोत्र भी विकसित हुये।
                </p>
                <p className="font-medium text-blue-700">
                  हमारे गोत्रों का विवरण यहाँ दिया जा रहा है। गोत्र का अर्थ नुख नहीं है। यह समझना आवश्यक है।
                </p>
              </div>
            </div>

            {/* Gotra Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {filteredGotras.map((gotra, index) => (
                <motion.div
                  key={gotra.id}
                  initial={{ y: 20, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: index * 0.03 }}
                  className="bg-white rounded-xl shadow-sm border border-blue-100 p-4 hover:shadow-md hover:border-blue-200 transition-all"
                >
                  <div className="flex items-start gap-3">
                    <span className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 font-bold flex-shrink-0">
                      {gotra.id}
                    </span>
                    <div className="flex-1">
                      <h3 className="font-bold text-gray-800">
                        {highlightText(gotra.name, searchTerm)}
                        <span className="text-sm font-normal text-gray-500 ml-2">
                          ({highlightText(gotra.nameEn, searchTerm)})
                        </span>
                      </h3>
                      <p className="text-sm text-gray-600 mt-1">
                        <span className="font-medium text-blue-600">नुखें: </span>
                        {highlightText(gotra.nukhs, searchTerm)}
                      </p>
                      <p className="text-xs text-gray-400 mt-0.5">
                        {highlightText(gotra.nukhsEn, searchTerm)}
                      </p>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>

            {filteredGotras.length === 0 && (
              <div className="text-center py-12 text-gray-500">
                <BookOpen size={48} className="mx-auto mb-4 opacity-50" />
                <p>कोई मिलान नहीं मिला / No matching gotra found</p>
              </div>
            )}

            {/* Gotra Table */}
            <motion.div
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.6 }}
              className="mt-12"
            >
              <h3 className="text-xl font-bold text-gray-800 mb-4">
                गोत्र से नुख मैपिंग / Gotra to Nukh Mapping
              </h3>
              <div className="bg-white rounded-xl shadow-sm border border-blue-100 overflow-hidden">
                <div className="overflow-x-auto">
                  <table className="w-full">
                    <thead className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white">
                      <tr>
                        <th className="px-4 py-3 text-left text-sm font-semibold">क्र.</th>
                        <th className="px-4 py-3 text-left text-sm font-semibold">गोत्र (Gotra)</th>
                        <th className="px-4 py-3 text-left text-sm font-semibold">नुखें (Nukhs)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {gotraData.map((gotra, idx) => (
                        <tr
                          key={gotra.id}
                          className={`border-b border-blue-50 ${idx % 2 === 0 ? 'bg-white' : 'bg-blue-50/30'}`}
                        >
                          <td className="px-4 py-3 text-gray-600">{gotra.id}</td>
                          <td className="px-4 py-3 font-medium text-gray-800">
                            {gotra.name}
                            <span className="text-sm text-gray-500 ml-1">({gotra.nameEn})</span>
                          </td>
                          <td className="px-4 py-3 text-gray-600">
                            <div>{gotra.nukhs}</div>
                            <div className="text-xs text-gray-400">{gotra.nukhsEn}</div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <p className="text-xs text-gray-500 mt-3 italic">
                (Disclaimer: With courtesy matter taken from the book of Shri Bhanwar Lalji Jarecha. We do not claim the perfectness or completeness of Gotras and Nukhs)
              </p>
            </motion.div>
          </motion.div>
        )}

        {/* Important Note */}
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.7 }}
          className="mt-12 bg-amber-50 border border-amber-200 rounded-xl p-6"
        >
          <h4 className="font-bold text-amber-800 mb-2 flex items-center gap-2">
            <Sparkles size={20} />
            महत्वपूर्ण नोट / Important Note
          </h4>
          <p className="text-amber-700 text-sm">
            अपने गोत्र में आने वाली नुखो को आपस में वैवाहिक संबंध नहीं बनाना चाहिए।
            <br />
            <span className="italic">Marriage should not be arranged between Nukh coming within the same Gotra.</span>
          </p>
        </motion.div>

        {/* Source Attribution */}
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.8 }}
          className="mt-8 text-center text-sm text-gray-500 italic"
        >
          <p>
            Disclaimer: With courtesy matter taken from the book of Shri Bhanwar Lalji Jarecha. We do not claim the perfectness or completeness of Gotras and Nukhs
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default BranchesAndNukhsPage;
